import '../../../styles/index.css'
import './MenuCategorias.css';
import CloseMenuLateral from '../../../assets/icons/Close Icon.svg'
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import $ from 'jquery';

function MenuCategorias() {

    const categorias = ['Armazenamentos', 'Coolers', 'Fontes', 'Gabinetes', 'Memórias RAM', 'Placas-Mãe', 'Placas de Vídeo', 'Processadores']

    useEffect(() => {

        const menuAtual = document.querySelector('.menu-lateral-esquerdo')

        menuAtual.addEventListener('show.bs.collapse', (event) => {
            $('<div class="overlay"></div>').appendTo(document.body);
            $('body').css('overflow', 'hidden')
        })

    }, [])

    const fecharMenu = () => {
        $('.botao-fechar-menu-categorias').click();
    }

    const removeOverlay = () => {
        $('.overlay').remove()
        $('body').css('overflow', 'auto')
    }

    return (

        <div className="menu-categorias-container">
            <div className='menu-lateral-esquerdo collapse collapse-horizontal' id="menuLateralEsquerdo">

                <button className='botao-fechar-menu-categorias' data-bs-toggle="collapse" data-bs-target="#menuLateralEsquerdo" aria-expanded="false" onClick={removeOverlay}>
                    <img src={CloseMenuLateral} alt="Fechar Menu Lateral" />
                </button>

                <ul className='menu-lateral-esquerdo-lista'>

                    {/* <li className='menu-lateral-esquerdo-link bt1' onClick={fecharMenu}><Link to="/" className="link">Home</Link></li>

                <li className='menu-lateral-esquerdo-link bt1' onClick={fecharMenu}><Link to="/Montagem" className="link">Monte seu PC</Link></li> */}

                    <Link to="/" className="link" onClick={fecharMenu}><li className='menu-lateral-esquerdo-link bt1'>Home</li></Link>

                    <Link to="/Montagem" className="link" onClick={fecharMenu}><li className='menu-lateral-esquerdo-link bt1'>Monte seu PC</li></Link>

                    {

                        categorias.map((categoria, index) => {
                            return (
                                // <li key={index} className='menu-lateral-esquerdo-categoria bt1' onClick={fecharMenu}><Link to={`/Pesquisa/${categoria}`} className="link">{categoria}</Link></li>

                                <Link key={index} to={`/Pesquisa/${categoria}`} className="link menu-lateral-esquerdo-categoria" onClick={fecharMenu}><li className='bt1'>{categoria}</li></Link>
                            )
                        })

                    }

                </ul>

            </div>
        </div>
    );
}

export default MenuCategorias;
